import PropTypes from 'prop-types'
import {
  Button,
  AlertDialog,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const ContinueWithoutSavingDialog = ({isOpen, onClose, onConfirmExit}) => {
  const {t} = useTranslation('invitePayers')

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent data-testid="exit-confirmation-dialog">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('confirmationDialog.title')}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <Button onClick={onClose}>
              {t('confirmationDialog.buttons.no')}
            </Button>
            <Button onClick={onConfirmExit} ml={3}>
              {t('confirmationDialog.buttons.yes')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

ContinueWithoutSavingDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmExit: PropTypes.func.isRequired,
}

export default ContinueWithoutSavingDialog
